const SEPARATOR_RE = /^_{5,}$/
const SECTION_HEADING_RE = /^\d+\.\s/
const META_LINE_RE = /^(Version|Effective Date|Last updated):/i
const BANNER_HEADING_RE = /^[A-Z][A-Z\s]+$/

export function parseLegalTextLines(raw: string): string[] {
  return raw
    .split(/\r?\n/)
    .map((line) => line.trimEnd())
    .map((line) =>
      line
        .replace('[Full Legal Name]', 'SpectrAI')
        .replace('[29.06.2026]', 'June 29, 2026')
        .replace('[Effective Date]', 'June 25, 2026')
        .replace('[Last Updated]', 'June 25, 2026'),
    )
    .filter((line) => {
      const trimmed = line.trim()
      return trimmed.length > 0 && !SEPARATOR_RE.test(trimmed) && trimmed !== 'END OF TERMS OF SERVICE' && trimmed !== 'End of Privacy Policy'
    })
}

export function isLegalMetaLine(line: string, index: number): boolean {
  if (index === 0) return false
  return META_LINE_RE.test(line.trim())
}

export function isLegalSectionHeading(line: string): boolean {
  const trimmed = line.trim()
  return SECTION_HEADING_RE.test(trimmed) || (trimmed.length > 4 && BANNER_HEADING_RE.test(trimmed))
}

/** Stable fragment id for numbered legal sections (e.g. Privacy §14 → `cookies`). */
export function legalSectionAnchorId(line: string): string | undefined {
  const match = line.trim().match(/^(\d+)\.\s+(.+)$/)
  if (!match) return undefined
  const [, num, title] = match
  if (num === '14' && /cookies/i.test(title)) return 'cookies'
  return `section-${num}`
}

export function isLegalBulletLine(line: string): boolean {
  return line.trimStart().startsWith('* ')
}

export function legalBulletText(line: string): string {
  return line.trimStart().slice(2).trim()
}
